import type { DialogProps } from "@mui/material";

type DialogCloseHandler = NonNullable<DialogProps["onClose"]>;

type DialogCancelOnCloseOptions = {
  enabled?: boolean;
  allowBackdropClick?: boolean;
};

export function dialogCancelOnClose(
  onCancel?: () => void,
  options?: DialogCancelOnCloseOptions,
): DialogCloseHandler {
  const enabled = options?.enabled ?? true;
  const allowBackdropClick = options?.allowBackdropClick ?? false;

  return (_event, reason) => {
    if (!enabled || !onCancel) {
      return;
    }
    if (reason === "backdropClick" && !allowBackdropClick) {
      return;
    }
    onCancel();
  };
}
